import { runDemo } from "../shared/demoRunner";
import { createSelfShadowingScene } from "./scene";

runDemo({ createScene: createSelfShadowingScene });
